import { requestAPI } from "."
const resource = 'orders'
const HOST = "https://api.calzzapato.com/api"

export const ticketAPI = {
  generateTicket: async (folio) => {
    return await requestAPI({
      host: HOST,
      method: 'GET',
      resource,
      endpoint: `/ticket/${folio}`
    })
  },
  generateTicketQR: async (folio) => {
    return await requestAPI({
      host: HOST,
      method: 'GET',
      resource,
      endpoint: `/ticket/qr/${folio}`
    })
  },
}
